export const groupName = 'Screenings';
export const credentialingSystemPermissions = {
    /**
     * Used for background checks
     */
    'add-quota': {
        group: groupName,
        label: 'Add Quota',
    },
    'download-forms': {
        group: groupName,
        label: 'Download Forms',
    },
    'manage-credentialing-classifiers': {
        group: groupName,
        label: 'Manage Credentialing Classifiers',
    },
    'manage-hospitals-classifier': {
        group: groupName,
        label: 'Manage Hospitals Classifier',
    },
    'manage-skills-and-trainings-classifiers': {
        group: groupName,
        label: 'Manage Skills and Trainings Classifiers',
    },
    'request-license-check': {
        group: groupName,
        label: 'Request License Check',
    },
    'view-ssn': {
        group: groupName,
        label: 'View SSN',
    },
    /**
     * Is used to permit navigation to the screenings page in the app
     */
    'view-screenings': {
        group: groupName,
        label: 'View Screenings',
    },
};
